var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
var cls = classNames('slice-question');
import AnimateHeight from 'react-animate-height';
import { first } from 'lodash';
import { Icon } from '../elements/icon';
import { ContentNode } from './content-node';
import { ImageEntity } from './image-entity';
import { DottedChevronDownIconGlyph, InfoIcon } from '@shapeable/icons';
export var SliceQuestionDefaultProps = {
  duration: 300,
  colors: {
    text: 'primary'
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    padding: ", " 0 ", ";\n    font-size: ", "em;\n  "], ["\n    ", ";\n    padding: ", " 0 ", ";\n    font-size: ", "em;\n  "])), theme.H_DOT_BG_END('sub'), theme.UNIT(3), theme.UNIT(2), 16 / 13),
  desktop: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " 0;\n  "], ["\n    padding: ", " 0;\n  "])), theme.UNIT(6))
});
var QuestionStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: inherit;\n    cursor: pointer;\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    margin-bottom ", ";\n    line-height: 1.25em;\n    font-weight: 400;\n\n    ", "\n\n    font-size: 1.25em;\n\n    &:hover {\n      filter: brightness(0.7);\n    }\n  "], ["\n    color: inherit;\n    cursor: pointer;\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    margin-bottom ", ";\n    line-height: 1.25em;\n    font-weight: 400;\n\n    ", "\n\n    font-size: 1.25em;\n\n    &:hover {\n      filter: brightness(0.7);\n    }\n  "])), theme.UNIT(5), function (_a) {
    var _color = _a._color;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), _color);
  })
});
var AnswerStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    color: inherit;\n    font-size: 1em;\n    font-weight: 300;\n    padding-bottom: ", ";\n\n    b, strong {\n      color: inherit;\n    }\n  "], ["\n    color: inherit;\n    font-size: 1em;\n    font-weight: 300;\n    padding-bottom: ", ";\n\n    b, strong {\n      color: inherit;\n    }\n  "])), theme.UNIT(2))
});
var IconStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "], ["\n    flex-shrink: 0;\n    margin-right: ", ";\n  "])), theme.UNIT(2)),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme.UNIT(3))
});
var DisclosureStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ImageStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    width: 100%;\n    max-width: 800px;\n  "], ["\n    width: 100%;\n    max-width: 800px;\n  "])))
});
var QuestionStartStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: flex;\n    padding-right: ", ";\n  "], ["\n    display: flex;\n    padding-right: ", ";\n  "])), theme.UNIT(2))
});
var DisclosureIconStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    transition: transform 0.3s;\n    flex-shrink: 0;\n    ", "\n  "], ["\n    transition: transform 0.3s;\n    flex-shrink: 0;\n    ", "\n  "])), function (_a) {
    var isExpanded = _a.isExpanded;
    return isExpanded && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      transform: rotate(180deg);\n    "], ["\n      transform: rotate(180deg);\n    "])));
  })
});
var BodyStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    padding: ", " 0;\n  "], ["\n    padding: ", " 0;\n  "])), theme.UNIT(6))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: styled(Icon)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Question: styled.h2.attrs(cls.attr('question'))(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), QuestionStyles),
  QuestionStart: styled.span.attrs(cls.attr('question-start'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), QuestionStartStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Answer: styled(ContentNode)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), AnswerStyles),
  Image: styled(ImageEntity)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Disclosure: styled.span.attrs(cls.attr('disclosure'))(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), DisclosureStyles),
  DisclosureIcon: styled(Icon).attrs(cls.attr('disclosure-icon'))(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), DisclosureIconStyles)
};
export var SliceQuestion = function (props) {
  var className = props.className,
    entity = props.entity,
    colors = props.colors,
    duration = props.duration;
  // @ts-ignore
  var _a = __read(React.useState(false), 2),
    isExpanded = _a[0],
    setIsExpanded = _a[1];
  var images = entity.images;
  var onClick = React.useCallback(function () {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);
  var Icon = props.iconComponent || InfoIcon;
  var image = first(images);
  var question = entity.title || entity.name;
  var answer = entity.content;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, question && React.createElement(My.Question, {
    onClick: onClick
  }, React.createElement(My.QuestionStart, null, React.createElement(My.Icon, {
    color: colors === null || colors === void 0 ? void 0 : colors.text,
    size: 32
  }, React.createElement(Icon, null)), question), React.createElement(My.DisclosureIcon, {
    isExpanded: isExpanded,
    size: 28,
    color: colors === null || colors === void 0 ? void 0 : colors.text
  }, React.createElement(DottedChevronDownIconGlyph, null))), React.createElement(AnimateHeight, {
    duration: duration,
    height: isExpanded ? "auto" : 0
  }, React.createElement(My.Body, null, image && React.createElement(My.Image, {
    entity: image
  }), answer && React.createElement(My.Answer, {
    entity: answer
  }))));
};
SliceQuestion.defaultProps = SliceQuestionDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22;